/**
 * Phone-number helpers shared by the contact CTA and the contact FAB.
 */

/** Strips everything but digits and a leading `+`, for use in a `tel:` href. */
export function toTelHref(value: string): string {
  const hasPlus = value.trim().startsWith("+");
  const digits = value.replace(/\D/g, "");
  return hasPlus ? `+${digits}` : digits;
}

/** Strips formatting and any leading zero, for use in a wa.me URL. */
export function toWhatsAppNumber(value: string): string {
  return value.replace(/\D/g, "").replace(/^0+/, "");
}
